import { QuestionExplanation } from '../../types'

export const METRIEK_EXPLANATIONS: Record<string, QuestionExplanation> = {
  'MET-OMT-L1-001': {
    id: 'MET-OMT-L1-001',
    explanation:
      'Je loopt helemaal rond de tuin. Tel alle kanten op: 12 + 8 + 12 + 8 = 40 meter.',
    distractorExplanations: {
      '0': 'Je telde maar 2 kanten (12 + 8). Een tuin heeft 4 kanten!',
      '2': 'Je deed 12 × 8. Dat is hoeveel gras erin past. Maar we willen weten: hoeveel hek eromheen?',
      '3': 'Bijna! Tel de vier kanten bij elkaar op: 12 + 8 + 12 + 8.',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 12,
        height: 8,
        mode: 'perimeter',
        label: 'Omtrek van de tuin',
      },
      showWhen: 'wrong',
    },
  },
  'MET-OMT-L2-001': {
    id: 'MET-OMT-L2-001',
    explanation:
      'Eerst reken je één rondje uit: 10 + 5 + 10 + 5 = 30 meter. Dan keer 3: 30 × 3 = 90 meter.',
    distractorExplanations: {
      '0': 'Je deed iets bij 30, maar vergat keer 3 te doen.',
      '1': 'Dit is maar één rondje! Je moest 3 rondjes lopen.',
      '3': 'Je deed 10 × 5 (hoeveel erin past) en toen keer 3. Maar we willen eromheen keer 3.',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 10,
        height: 5,
        mode: 'perimeter',
        label: 'Zwembad (1 rondje = 30m)',
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L1-001': {
    id: 'MET-INH-L1-001',
    explanation:
      'Maak het gelijk: 1,5 liter = 1500 ml. Dan delen: 1500 : 250 = 6 glazen.',
    distractorExplanations: {
      '0': 'Je gebruikte 1 liter (1000 ml). Maar er zit 1,5 liter in de fles!',
      '2': 'Check nog eens: 1500 : 250 = 6.',
      '3': 'Let op de komma! 1,5 liter is 1500 ml, niet 15.000 ml.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'volume',
        from: 'l',
        to: 'ml',
        value: 1.5,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-OPP-L3-002': {
    id: 'MET-OPP-L3-002',
    explanation:
      'Bij een vierkant zijn alle zijden even lang. Welk getal × zichzelf = 36? Dat is 6, want 6 × 6 = 36.',
    distractorExplanations: {
      '1': 'Je deed 36 : 4. Maar dat is voor eromheen, niet voor hoeveel erin past!',
      '2': 'Je deed 36 : 2. Maar zoek een getal dat × zichzelf = 36.',
      '3': 'Te klein! Probeer: 4 × 4 = 16. Dat is geen 36.',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 6,
        height: 6,
        mode: 'area',
        label: 'Vierkant: 6 × 6 = 36 cm²',
      },
      showWhen: 'wrong',
    },
  },
  'MET-LEN-L2-002': {
    id: 'MET-LEN-L2-002',
    explanation:
      'Van km naar dm zijn het 4 trapjes omlaag 📉. Elke trap is ×10. Dus: 4,5 × 10 × 10 × 10 × 10 = 45.000 dm.',
    distractorExplanations: {
      '0': 'Te vroeg gestopt! Van km naar dm zijn het 4 stapjes.',
      '1': 'Je stopte bij meter. Nog één stapje verder naar dm!',
      '3': 'Eén stapje te ver! Je kwam bij cm uit.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'length',
        from: 'km',
        to: 'dm',
        value: 4.5,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L3-001': {
    id: 'MET-INH-L3-001',
    explanation:
      'Inhoud = hoeveel past erin. Doe lengte × breedte × hoogte: 5 × 4 × 3 = 60. En 1 dm³ = 1 liter!',
    distractorExplanations: {
      '0': 'Je deed 5 + 4 + 3. Maar bij "hoeveel past erin" moet je keer elkaar doen!',
      '2': 'Check nog eens: 5 × 4 = 20, en 20 × 3 = 60.',
      '3': 'Je deed alleen de bodem (5 × 4). Maar je moet ook keer de hoogte!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Inhoud Berekenen',
        content:
          'Inhoud = hoeveel past erin. Reken: lengte × breedte × hoogte. Alle drie keer elkaar!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'MET-OPP-L1-001': {
    id: 'MET-OPP-L1-001',
    explanation:
      'Tegels gaan op de vloer. Dat is hoeveel erin past! Doe lengte × breedte: 8 × 6 = 48 m².',
    distractorExplanations: {
      '0': 'Je deed 8 + 6. Maar bij "hoeveel erin past" moet je keer elkaar doen!',
      '2': 'Je rekende eromheen (8 + 6 + 8 + 6). Maar we willen de vloer weten!',
      '3': 'Het getal klopt! Maar let op: het is m² (vierkante meter), niet m.',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 8,
        height: 6,
        mode: 'area',
        label: 'Klaslokaal: 8 × 6 = 48 m²',
      },
      showWhen: 'wrong',
    },
  },
  'MET-LEN-L2-001': {
    id: 'MET-LEN-L2-001',
    explanation:
      'Van km naar m zijn het 3 trapjes omlaag. Elke trap is ×10. Dus: 1,5 × 10 × 10 × 10 = 1500 meter.',
    distractorExplanations: {
      '0': 'Je stopte bij hectometer. Nog één stapje verder naar meter!',
      '2': 'Je deelde in plaats van keer gedaan. Een kilometer is juist veel groter dan een meter!',
      '3': 'Te veel nullen! Check: 1,5 × 1000 = 1500.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'length',
        from: 'km',
        to: 'm',
        value: 1.5,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L2-001': {
    id: 'MET-INH-L2-001',
    explanation:
      'Maak het gelijk: 1 liter = 10 deciliter. Dan eraf: 10 - 2 = 8 dl.',
    distractorExplanations: {
      '0': 'Je probeerde 1 - 0,2. Maar zet eerst alles in deciliter!',
      '2': 'Je dacht dat 1 liter = 100 deciliter. Kijk naar het trapje: 1 L = 10 dl!',
      '3': 'Je deed erbij in plaats van eraf. Er gaat juist melk uit het pak!',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'volume',
        from: 'l',
        to: 'dl',
        value: 1,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-OMT-L3-001': {
    id: 'MET-OMT-L3-001',
    explanation:
      'De twee lange kanten = 200m (100 + 100). Dan blijft 100m over voor de twee korte kanten. Elke korte kant = 100 : 2 = 50m.',
    distractorExplanations: {
      '0': 'Dit is voor de twee korte kanten samen. Deel het nog door 2!',
      '2': 'Dan zou het vierkant zijn. Check: 100 + 100 + 100 + 100 = 400. Dat is te veel!',
      '3': 'Je deed 300 : 2. Maar haal eerst de twee lange kanten eraf!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Omtrek Terugrekenen',
        content:
          'Als je de omtrek weet, kun je een kant uitrekenen. Trek eerst de andere kanten eraf!',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'MET-OPP-L3-001': {
    id: 'MET-OPP-L3-001',
    explanation:
      'Bij een vierkant zijn alle kanten even lang. Welk getal × zichzelf = 81? Probeer: 9 × 9 = 81. Dus de zijkant is 9 cm!',
    distractorExplanations: {
      '1': 'Je deed 81 : 4. Dat doe je bij eromheen, niet bij hoeveel erin past!',
      '2': 'Je deed 81 : 2. Maar zoek een getal dat × zichzelf = 81.',
      '3': 'Dit is hoeveel erin past, niet de lengte van één kant!',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 9,
        height: 9,
        mode: 'area',
        label: 'Vierkant: 9 × 9 = 81 cm²',
      },
      showWhen: 'wrong',
    },
  },
  'MET-LEN-L1-002': {
    id: 'MET-LEN-L1-002',
    explanation:
      'Van cm naar m zijn het 2 stappen omhoog op de trap. Dus delen door 100: 250 : 100 = 2,5 meter.',
    distractorExplanations: {
      '0': 'Je deelde door 1000. Dat is van mm naar m!',
      '2': 'Je deelde door 10. Dat is van cm naar dm!',
      '3': 'Dit is hetzelfde getal. Je moet het omrekenen naar meters.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'length',
        from: 'cm',
        to: 'm',
        value: 250,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-GEW-L1-001': {
    id: 'MET-GEW-L1-001',
    explanation:
      'Van kg naar gram zijn het 3 stappen omlaag. Elke stap is ×10. Dus: 3 × 1000 = 3.000 gram.',
    distractorExplanations: {
      '0': 'Je deed ×10. Dat is naar ons (hg)!',
      '1': 'Je deed ×100. Dat is naar dag!',
      '3': 'Een nul te veel. 1 kg = 1000 gram, dus 3 kg = 3000 gram.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'weight',
        from: 'kg',
        to: 'g',
        value: 3,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-OMT-L1-002': {
    id: 'MET-OMT-L1-002',
    explanation:
      'Omtrek = eromheen lopen. Loop langs alle vier de kanten: 9 + 4 + 9 + 4 = 26 meter.',
    distractorExplanations: {
      '0': 'Je telde maar twee kanten (9 + 4). Een rechthoek heeft vier kanten!',
      '2': 'Je deed 9 × 4. Dat is hoeveel erin past, niet eromheen!',
      '3': 'Je deed hoeveel erin past × 2. Dat klopt niet voor eromheen.',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 9,
        height: 4,
        mode: 'perimeter',
        label: 'Omtrek: 9 + 4 + 9 + 4 = 26m',
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L1-002': {
    id: 'MET-INH-L1-002',
    explanation:
      'Kijk hoe vaak 1,5 in 7,5 past: 1,5 + 1,5 = 3. Dan 3 + 3 = 6. Nog 1,5 erbij = 7,5. Dat is 5 keer!',
    distractorExplanations: {
      '0': '3 flessen = 4,5 liter. Dat is te weinig.',
      '1': '4 flessen = 6 liter. Er blijft nog 1,5 liter over!',
      '3': '6 flessen = 9 liter. Zoveel water heb je niet.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Verdelen',
        content: '7,5 : 1,5 = 5. Je kunt 5 flessen vullen.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'MET-OPP-L2-001': {
    id: 'MET-OPP-L2-001',
    explanation:
      'Voor vloerbedekking heb je "hoeveel erin past" nodig. Lengte × breedte: 4 × 3,5 = 14 m².',
    distractorExplanations: {
      '0': 'Je deed 4 + 3,5. Maar bij "hoeveel erin past" moet je keer elkaar doen!',
      '2': 'Je verdubbelde de uitkomst. Maar 4 × 3,5 = 14.',
      '3': 'Je deed 4 × 3. Vergeet de halve meter niet! 4 × 0,5 = 2. Dan 12 + 2 = 14.',
    },
    visualAid: {
      type: 'geo',
      data: {
        width: 4,
        height: 3.5,
        mode: 'area',
        label: 'Oppervlakte: 4 × 3,5 = 14 m²',
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L2-002': {
    id: 'MET-INH-L2-002',
    explanation:
      'Zet eerst alles om naar dm: 2 m = 20 dm, 50 cm = 5 dm, 20 cm = 2 dm. Inhoud = 20 × 5 × 2 = 200 dm³.',
    distractorExplanations: {
      '0': 'Je deed de getallen in dm bij elkaar. Maar je moet ze keer elkaar doen!',
      '2': 'Check of je alles goed omzette: 20 × 5 × 2 = 200.',
      '3': 'Je rekende met cm of m. Zet EERST alles om naar dm!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Inhoud in dm³',
        content:
          'Zet EERST alles om naar dm. Dan pas rekenen: 20 × 5 × 2 = 200 dm³',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L3-002': {
    id: 'MET-INH-L3-002',
    explanation:
      '1 kubieke meter (m³) = precies 1000 liter. Dus delen door 1000: 18.000 : 1000 = 18 m³.',
    distractorExplanations: {
      '0': 'Je deelde door 10.000. Maar 1 m³ = 1000 liter.',
      '2': 'Je deelde door 100. Maar er gaan 1000 liter in een kuub!',
      '3': 'Je deelde door 10. Dat is te weinig.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'volume',
        from: 'l',
        to: 'm3',
        value: 18000,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-LEN-L3-001': {
    id: 'MET-LEN-L3-001',
    explanation:
      'Maak de maten gelijk: 120 meter = 12.000 cm. Dan delen: 12.000 : 40 = 300 tegels.',
    distractorExplanations: {
      '0': 'Je deed 120 : 4. Maar 120 is meters en 40 is centimeters!',
      '1': 'Je deed 1200 : 40. Maar 120 meter = 12.000 cm!',
      '3': 'Een nul te veel. Check: 12.000 : 40 = 300.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Gelijke Maten',
        content:
          'Reken nooit met meters en cm door elkaar! Maak er eerst allemaal cm van.',
        icon: 'alert',
      },
      showWhen: 'wrong',
    },
  },
  'MET-GEW-L1-002': {
    id: 'MET-GEW-L1-002',
    explanation:
      'Stap 1: 1 kilogram = 1000 gram.\nStap 2: Hoeveel keer past 200 gram in 1000 gram?\nStap 3: 1000 : 200 = 5.\nJe hebt 5 appels nodig voor 1 kilogram.',
    distractorExplanations: {
      '1': 'Je deed 1000 : 100. Maar één appel weegt 200 gram, niet 100 gram!',
      '2': 'Je deed 1000 : 500. Maar één appel weegt 200 gram, niet 500 gram!',
      '3': 'Je deed 1000 : 50. Maar één appel weegt 200 gram, niet 50 gram!',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'weight',
        from: 'kg',
        to: 'g',
        value: 1,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-GEW-L2-001': {
    id: 'MET-GEW-L2-001',
    explanation:
      'Van kilogram naar gram zijn het 3 stappen omlaag op de trap.\nElke stap is ×10.\nDus: 2,5 × 10 × 10 × 10 = 2,5 × 1000 = 2.500 gram.',
    distractorExplanations: {
      '1': 'Je deed ×100. Dat is van kg naar dag (decagram)!',
      '2': 'Je deed ×10. Dat is van kg naar hg (hectogram)!',
      '3': 'Een nul te veel! 1 kg = 1000 gram, dus 2,5 kg = 2.500 gram.',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'weight',
        from: 'kg',
        to: 'g',
        value: 2.5,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L2-003': {
    id: 'MET-INH-L2-003',
    explanation:
      'Stap 1: Maak de maten gelijk. 8 liter = 8.000 ml.\nStap 2: Hoeveel keer past 500 ml in 8.000 ml?\nStap 3: 8.000 : 500 = 16.\nJe kunt 16 bekers vullen!',
    distractorExplanations: {
      '1': 'Je deed 8 : 0,5 = 16. Dat klopt! Maar het antwoord is 16 bekers, niet 8.',
      '2': 'Je deed 8.000 : 1000. Maar één beker is 500 ml, niet 1000 ml!',
      '3': 'Je deed 8.000 : 250. Maar één beker is 500 ml, niet 250 ml!',
    },
    visualAid: {
      type: 'stairs',
      data: {
        type: 'volume',
        from: 'l',
        to: 'ml',
        value: 8,
        showAnimation: true,
      },
      showWhen: 'wrong',
    },
  },
  'MET-GEW-L3-001': {
    id: 'MET-GEW-L3-001',
    explanation:
      'Stap 1: De vrachtwagen mag maximaal 3.500 kg laden.\nStap 2: Er staat al 2.750 kg in.\nStap 3: Hoeveel mag er nog bij? Trek af: 3.500 - 2.750 = 750 kg.\nEr mag nog 750 kilogram bij.',
    distractorExplanations: {
      '1': 'Rekenfoutje bij het aftrekken. Check: 3.500 - 2.750 = 750.',
      '2': 'Rekenfoutje bij het aftrekken. Check: 3.500 - 2.750 = 750.',
      '3': 'Je deed 3.500 - 2.500. Maar er staat al 2.750 kg in, niet 2.500 kg!',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Maximaal Gewicht',
        content: 'Maximaal gewicht - wat er al in zit = wat er nog bij mag.',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
  'MET-INH-L3-003': {
    id: 'MET-INH-L3-003',
    explanation:
      'Stap 1: Bereken de inhoud in cm³: 50 × 30 × 40 = 60.000 cm³.\nStap 2: Reken om naar liter. 1 liter = 1.000 cm³.\nStap 3: 60.000 : 1.000 = 60 liter.\nEr past 60 liter water in het aquarium.',
    distractorExplanations: {
      '1': 'Je deed 50 × 30 × 40 = 60.000 en dacht dat dit liter was. Maar dit is cm³! Deel door 1000 om liter te krijgen.',
      '2': 'Je deed alleen 50 × 30 = 1.500 en deelde door 50. Maar je moet ook keer de hoogte (40)!',
      '3': 'Je deed 50 × 30 × 40 zonder om te rekenen naar liter. 60.000 cm³ = 60 liter.',
    },
    visualAid: {
      type: 'rule',
      data: {
        title: 'Inhoud: cm³ naar Liter',
        content:
          'Stap 1: Reken inhoud in cm³ (lengte × breedte × hoogte).\nStap 2: Deel door 1000 om liter te krijgen.\n1 liter = 1.000 cm³',
        icon: 'lightbulb',
      },
      showWhen: 'wrong',
    },
  },
}
